(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-ledger"] && !Shopify.designMode) return;
  try {
    
/* Marca la entrada sobre la que esta el cursor (o el foco) y cambia la imagen
   de fondo si esa entrada trae la suya. Un solo listener por seccion. */
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-cm-ledger]').forEach(function (wrap) {
      if (wrap.dataset.cmLedgerReady === '1') return;
      wrap.dataset.cmLedgerReady = '1';

      var stage = wrap.querySelector('.cm-ledger__stage');
      var entries = wrap.querySelectorAll('.cm-ledger__entry');
      if (!entries.length) return;

      function activate(index) {
        entries.forEach(function (e) {
          e.classList.toggle('is-active', e.dataset.cmLedgerEntry === String(index));
        });
        var any = false;
        wrap.querySelectorAll('[data-cm-ledger-media]').forEach(function (m) {
          var on = m.dataset.cmLedgerMedia === String(index);
          m.classList.toggle('is-on', on);
          if (on) any = true;
        });
        if (stage) stage.classList.toggle('has-on', any);
      }

      entries.forEach(function (entry) {
        var i = entry.dataset.cmLedgerEntry;
        entry.addEventListener('mouseenter', function () { activate(i); });
        entry.addEventListener('focusin', function () { activate(i); });
      });

      activate(entries[0].dataset.cmLedgerEntry);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
